import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import supplierActions from '../../actions/supplierActions';
import ModalConfirm from '../common/modals/ModalConfirm';
import ModalSupplierForm from '../common/modals/ModalSupplierForm';
import SearchBar from '../common/layout/SearchBar';
import BaseComponent from '../base/BaseComponent';
import TableList from '../common/datatables/TableList';
import _ from 'lodash';
import I18n from 'i18n-js';
import { SEARCH_BAR_EVENT, SEARCH_KEY, SEARCH_LIST } from "../../constants/constants";
import './style.scss';
import CustomPagination from '../common/datatables/CustomPagination';

class TabSuppliers extends BaseComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tabActive: '',
      pageSize: 10,
      pageNumber: 1,
      columns: [
        { name: I18n.t('PageCrm.Name'), value: 'name' },
        { name: I18n.t('PageCrm.ShortName'), value: 'shortName' },
        { name: I18n.t('PageCrm.Company'), value: 'company.name' },
        { name: I18n.t('PageCrm.Address'), value: 'company.address' },
        { name: I18n.t('PageCrm.Email'), value: 'email' },
        { name: I18n.t('PageCrm.Phone'), getValue: (i) => {
          let phoneNumber = i.phoneNumber == '+' ? '-': i.phoneNumber;
          return phoneNumber;
        }, options: { clsTh: 'center', clsTd: 'center' } },
        { name: I18n.t('PageCrm.Fax'), value: 'fax', options: { clsTh: 'center', clsTd: 'center' } },
        { name: I18n.t('PageCrm.BankAccNo'), value: 'bank.accountNo', options: { clsTh: 'center', clsTd: 'center' } },
        { name: I18n.t('PageCrm.Division'), value: 'division', options: { clsTh: 'center', clsTd: 'center' } },
        {
          name: I18n.t('PageCrm.DeliveryDeviation'),
          value: 'deliveryDeviation',
          options: { clsTh: 'center', clsTd: 'center' }
        },
        { name: I18n.t('PageCrm.PaymentTerm'), value: 'paymentTerm', options: { clsTh: 'center', clsTd: 'center' } }
      ],
      items: [],
      total: 0,
      searchFields: [
        { name: I18n.t('PageCrm.Name'), field: 'name' },
        { name: I18n.t('PageCrm.Email'), field: 'email' },
        { name: I18n.t('PageCrm.Phone'), field: 'phoneNumber' },
        { name: I18n.t('PageCrm.Fax'), field: 'fax' },
        { name: I18n.t('PageCrm.Division'), field: 'division' },
      ],
      searchValue: {},
      search: { key: SEARCH_KEY.NAME, value: "" },
    };

    this.onDeleteSupplier = this.onDeleteSupplier.bind(this);
  }

  componentWillMount() {
    this.getListSupplier();
  }

  componentWillReceiveProps(newProps) {
    let { items } = this.state;
    !_.isEqual(items, newProps.supplierState.items) && this.setState({
      items: _.cloneDeep(newProps.supplierState.items) || [],
      total: newProps.supplierState.count || 0
    });
    this.props.tabCurrent !== newProps.tabCurrent && this.closeFormAdd();
  }

  componentWillUpdate(nextProps, nextState) {
    let { searchValue } = this.state;
    if (_.get(this.props.supplierState, 'reload') != _.get(nextProps.supplierState, 'reload')) {
      this.search(nextState.search, nextState.pageNumber, nextState.pageSize);
    }
    _.get(this.props.supplierState, 'reload') != _.get(nextProps.supplierState, 'reload') && this.props.modal.closeModal();
  }

  getListSupplier(query = {}) {
    let { pageSize, pageNumber } = this.state;
    let _query = _.assign({ pageSize: pageSize, pageNumber: pageNumber }, query);
    this.props.supplierActions.getListSupplier(_.set(_query, 'sort', { createdAt: -1 }));
  }

  showDeleteConfirm(item) {
    let { openModal, closeModal } = this.props.modal;
    let modal = (<ModalConfirm
      title={I18n.t('PageCrm.DELETESUPPLIER')}
      confirmMessage={I18n.t('PageCrm.ConfirmDeleteSupplier')}
      messageOk={I18n.t('Btn.YES')}
      messageCancel={I18n.t('Btn.CANCEL')}
      handleClose={closeModal}
      handleOk={this.onDeleteSupplier.bind(null, item)} />);
    openModal(modal);
  }

  addOrUpdateSupplier = (item) => {
    let { openModal, closeModal } = this.props.modal;
    let modal = (<ModalSupplierForm closeModal={closeModal} supplierDetail={item} resetList={success => {success && this.getListSupplier()}}/>);
    openModal(modal);
  }

  onDeleteSupplier(item) {
    item._id && this.props.supplierActions.deleteSupplier(item._id);
  }

  selectPage = (page) => {
    this.setState({ pageNumber: page });
    this.search(this.state.search, page, this.state.pageSize);
  }

  onChangeSearch(property, value) {
    switch (property) {
      case SEARCH_BAR_EVENT.FILTER: {
        this.setState({ search: { key: value, value: "" } });
        break;
      }
      case SEARCH_BAR_EVENT.SEARCH: {
        this.setState({ search: { ...this.state.search, value: value } });
        break;
      }
    }
  }

  onSearch() {
    const { search, pageNumber, pageSize } = this.state;
    this.search(search, pageNumber, pageSize);
  }

  search(search, pageNumber, pageSize) {
    let options = {};
    const populate = '';
    if (search && search.key && search.value) {
      switch (search.key) {
        case SEARCH_KEY.NAME: {
          options = {
            pageNumber,
            pageSize,
            sort: { updatedAt: -1 },
            populate: populate,
            query: { name: { $regex: '.*' + search.value + '.*', $options: 'i' } }
          };
          this.props.supplierActions.getListSupplier(options).then(res => {
            if (res && res.success && res.data && res.data.items && !res.data.items.length && pageNumber > 1) {
              options = {
                pageNumber: 1,
                pageSize,
                sort: { updatedAt: -1 },
                populate: populate,
                query: { name: { $regex: '.*' + search.value + '.*', $options: 'i' } }
              };
              this.setState({ pageNumber: 1 });
              this.props.supplierActions.getListSupplier(options)
            }
          });
          break;
        }
        case SEARCH_KEY.COMPANY: {
          options = {
            pageNumber,
            pageSize,
            sort: { updatedAt: -1 },
            populate: populate,
            query: { "company.name": { $regex: '.*' + search.value + '.*', $options: 'i' } }
          };
          this.props.supplierActions.getListSupplier(options).then(res => {
            if (res && res.success && res.data && res.data.items && !res.data.items.length && pageNumber > 1) {
              options = {
                pageNumber: 1,
                pageSize,
                sort: { updatedAt: -1 },
                populate: populate,
                query: { "company.name": { $regex: '.*' + search.value + '.*', $options: 'i' } }
              };
              this.setState({ pageNumber: 1 });
              this.props.supplierActions.getListSupplier(options)
            }
          });
          break;
        }
        case SEARCH_KEY.ADDRESS: {
          options = {
            pageNumber,
            pageSize,
            sort: { updatedAt: -1 },
            populate: populate,
            query: { "company.address": { $regex: '.*' + search.value + '.*', $options: 'i' } }
          };
          this.props.supplierActions.getListSupplier(options).then(res => {
            if (res && res.success && res.data && res.data.items && !res.data.items.length && pageNumber > 1) {
              options = {
                pageNumber: 1,
                pageSize,
                sort: { updatedAt: -1 },
                populate: populate,
                query: { "company.address": { $regex: '.*' + search.value + '.*', $options: 'i' } }
              };
              this.setState({ pageNumber: 1 });
              this.props.supplierActions.getListSupplier(options)
            }
          });
          break;
        }
        case SEARCH_KEY.EMAIL: {
          options = {
            pageNumber,
            pageSize,
            sort: { updatedAt: -1 },
            populate: populate,
            query: { email: { $regex: '.*' + search.value + '.*', $options: 'i' } }
          };
          this.props.supplierActions.getListSupplier(options).then(res => {
            if (res && res.success && res.data && res.data.items && !res.data.items.length && pageNumber > 1) {
              options = {
                pageNumber: 1,
                pageSize,
                sort: { updatedAt: -1 },
                populate: populate,
                query: { email: { $regex: '.*' + search.value + '.*', $options: 'i' } }
              };
              this.setState({ pageNumber: 1 });
              this.props.supplierActions.getListSupplier(options)
            }
          });
          break;
        }
        case SEARCH_KEY.DIVISION: {
          options = {
            pageNumber,
            pageSize,
            sort: { updatedAt: -1 },
            populate: populate,
            query: { division: { $regex: '.*' + search.value + '.*', $options: 'i' } }
          };
          this.props.supplierActions.getListSupplier(options).then(res => {
            if (res && res.success && res.data && res.data.items && !res.data.items.length && pageNumber > 1) {
              options = {
                pageNumber: 1,
                pageSize,
                sort: { updatedAt: -1 },
                populate: populate,
                query: { division: { $regex: '.*' + search.value + '.*', $options: 'i' } }
              };
              this.setState({ pageNumber: 1 });
              this.props.supplierActions.getListSupplier(options)
            }
          });
          break;
        }
        case SEARCH_KEY.PAYMENT_TERM: {
          options = {
            pageNumber,
            pageSize,
            sort: { updatedAt: -1 },
            populate: populate,
            query: { paymentTerm: { $regex: '.*' + search.value + '.*', $options: 'i' } }
          };
          this.props.supplierActions.getListSupplier(options).then(res => {
            if (res && res.success && res.data && res.data.items && !res.data.items.length && pageNumber > 1) {
              options = {
                pageNumber: 1,
                pageSize,
                sort: { updatedAt: -1 },
                populate: populate,
                query: { paymentTerm: { $regex: '.*' + search.value + '.*', $options: 'i' } }
              };
              this.setState({ pageNumber: 1 });
              this.props.supplierActions.getListSupplier(options)
            }
          });
          break;
        }
      }
    }
    if (!search.value) {
      let options = {
        pageNumber,
        pageSize,
        sort: { updatedAt: -1 },
        populate: populate,
      };
      this.props.supplierActions.getListSupplier(options).then(res => {
        if (res && res.success && res.data && res.data.items && !res.data.items.length && pageNumber > 1) {
          options = {
            pageNumber: 1,
            pageSize,
            sort: { updatedAt: -1 },
            populate: populate,
          };
          this.setState({ pageNumber: 1 });
          this.props.supplierActions.getListSupplier(options);
        }
      });
    }
  }

  render() {
    let { items, total, columns, pageNumber, pageSize, searchFields } = this.state;
    let { roles: {showCreate, showEdit, showDelete} } = this.props;
    let actions = [
      (item) => {
        return showEdit ? { type: 'edit', click: (item) => this.addOrUpdateSupplier(item) } : {};
      },
      (item) => {
        return showDelete ? { type: 'delete', click: (item) => this.showDeleteConfirm(item) } : {};
      }
    ];
    let totalPage = _.ceil(total / pageSize);
    return (

      <div role="tabpanel" className="tab-pane" id="crm-suppliers">
        <div className="wrap-search-position">
          <SearchBar
            name={I18n.t('PageCrm.AddNew')}
            addItem={showCreate ? () => this.addOrUpdateSupplier() : null}
            fields={SEARCH_LIST.CRM_SUPPLIER}
            onChangeSearch={(type, data) => this.onChangeSearch(type, data)}
            onSearch={() => this.onSearch()}
          />
        </div>
        <TableList {...this.props} items={items || []} columns={columns || []} actions={actions || []}
          options={{ clsTbl: 'global-table box-shadow-none' }} widthAction="w-70" />
        <CustomPagination items={totalPage} activePage={pageNumber} onSelect={this.selectPage} />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    appState: state.appState,
    authState: state.authState,
    supplierState: state.supplierState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    supplierActions: bindActionCreators(supplierActions, dispatch)
  };
}

TabSuppliers.propTypes = {
  authState: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(TabSuppliers);
